/* eslint-disable no-unused-expressions */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Row, Col, Card, CardBody, Button, Spinner,
  FormGroup, Label, Input, CardHeader, FormFeedback,
} from 'reactstrap'
import DeleteRecordByAdmin from '../../components/Modal/DeleteRecordByAdmin'
import DataTable from '../../components/Template/Table/DataTable'
import MaskedInput from '../../components/Template/Input/MaskedInput'
import AsyncSelect from '../../components/Template/Input/AsyncSelect'
import oikosApi from '../../services/oikos'
import { notifyError, notifySuccess } from '../../utils/notify'
import { getSectors } from '../../store/ducks/admin'
import { getDepartmentTypes } from '../../store/ducks/types'
import { getFieldsForSectors } from '../../store/ducks/forms'

class Sectors extends Component {
  constructor(props) {
    super(props)
    this.state = {
      record: {},
      formErrors: {},
      addRecordModalIsOpen: false,
      editRecordModalIsOpen: false,
      handleFormSubmitIsLoading: false,
      deleteRecordModalIsOpen: false,
      deleteRecordId: null,
      deleteRecordName: '',
    }
  }

  componentDidMount() {
    const { getSectors, getDepartmentTypes, getFieldsForSectors } = this.props

    getSectors()
    getDepartmentTypes()
    getFieldsForSectors()
  }

  toggleModal = action => {
    const { handleFormSubmitIsLoading, addRecordModalIsOpen, editRecordModalIsOpen } = this.state

    if (handleFormSubmitIsLoading) return null

    if (action === 'insert') {
      this.setState(prevState => ({
        addRecordModalIsOpen: !prevState.addRecordModalIsOpen,
      }))

      if (addRecordModalIsOpen) this.setState({ record: {}, formErrors: {} })
    } else if (action === 'update') {
      this.setState(prevState => ({
        editRecordModalIsOpen: !prevState.editRecordModalIsOpen,
      }))

      if (editRecordModalIsOpen) this.setState({ record: {}, formErrors: {} })
    }

    return null
  }

  handleFormSubmit = async action => {
    try {
      this.setState({ handleFormSubmitIsLoading: true })

      const isValid = this.validateForm()

      if (isValid) {
        const { record } = this.state

        const data = Object.fromEntries(Object.entries(record).filter((...[, v]) => v !== null))

        const body = {
          table: 'setor',
          action,
          data,
        }

        await oikosApi.post('/', body)

        notifySuccess(`Registro ${action === 'update' ? 'editado' : 'adicionado'} com sucesso.`)

        this.setState({
          handleFormSubmitIsLoading: false,
          addRecordModalIsOpen: false,
          editRecordModalIsOpen: false,
          record: {},
        })

        this.componentDidMount()
      }

      this.setState({ handleFormSubmitIsLoading: false })
    } catch (e) {
      this.setState({ handleFormSubmitIsLoading: false })
      notifyError(`Não foi possível ${action === 'update' ? 'editar' : 'adicionar'} o registro.`)
      console.tron.log(`Não foi possível ${action === 'update' ? 'editar' : 'adicionar'} o registro.`, e)
    }
  }

  validateForm = () => {
    const { record } = this.state
    const { fieldsForSectors } = this.props.forms
    const formErrors = {}
    let isValid = true

    fieldsForSectors?.fields?.forEach(field => {
      if (!field.primary && field.required === 1 && record[field.name] === undefined) {
        isValid = false
        formErrors[field.name] = 'Obrigatório'
      }
    })

    this.setState({ formErrors })
    return isValid
  }

  render() {
    const {
      addRecordModalIsOpen, editRecordModalIsOpen,
      record, handleFormSubmitIsLoading, formErrors,
      deleteRecordModalIsOpen, deleteRecordId, deleteRecordName,
    } = this.state

    const {
      departmentTypes,
    } = this.props.types

    const {
      getFieldsForSectorsIsLoading, fieldsForSectors,
    } = this.props.forms

    const {
      getSectorsIsLoading, sectors,
    } = this.props.admin

    const records = sectors
    const getRecordsIsLoading = getSectorsIsLoading

    if (addRecordModalIsOpen || editRecordModalIsOpen) {
      return (
        <>
          <Row>
            <Col>
              <h4>
                {`${addRecordModalIsOpen ? 'Adicionar' : 'Editar'}`} registro
              </h4>
            </Col>

            <Col className="d-flex justify-content-end">
              <Button
                color="light"
                size="sm"
                onClick={() => this.toggleModal(addRecordModalIsOpen ? 'insert' : 'update')}
              >
                <i className="ri-close-fill font-size-16" />
              </Button>
            </Col>
          </Row>

          <Row className="mt-3">
            <Col>
              <Card>
                <CardHeader>
                  Setor
                </CardHeader>
                <CardBody className="pb-3">
                  {getFieldsForSectorsIsLoading && (
                    <Row>
                      <Col className="d-flex align-items-center justify-content-center py-3">
                        <Spinner size="sm" />
                      </Col>
                    </Row>
                  )}

                  {!getFieldsForSectorsIsLoading && fieldsForSectors && (
                    <Row>
                      {fieldsForSectors.fields.map(field => (
                        <Col xs={12} sm={6} lg={3}>
                          <FormGroup key={field.name}>
                            <Label>
                              {`${field.label}${field.required ? '*' : ''}`}
                            </Label>

                            {field.primary === 1 && (
                              <Input
                                disabled
                                value={record[field.name]}
                              />
                            )}

                            {field.type === 'currency' && (
                              <MaskedInput
                                unmask
                                invalid={formErrors[field.name]}
                                mask="R$ num"
                                blocks={{
                                  num: {
                                    mask: Number,
                                    scale: 2, // digits after point 0 for integers
                                    signed: false, // disallow negative
                                    thousandsSeparator: '.', // any single char
                                    padFractionalZeros: false, // if true then pads zeros at end to the length of scale
                                    normalizeZeros: false,
                                    radix: ',',
                                    min: 0,
                                    max: 1000000000,
                                  },
                                }}
                                lazy={false}
                                value={record[field.name]?.toString()}
                                onAccept={(value) => this.setState(prevState => ({
                                  record: {
                                    ...prevState.record,
                                    [field.name]: Number(value),
                                  },
                                  formErrors: {
                                    ...prevState.formErrors,
                                    [field.name]: undefined,
                                  },
                                }))}
                              />
                            )}

                            {(field.type === 'select' || field.type === 'multiselect') && (
                              <AsyncSelect
                                cacheOptions
                                defaultOptions
                                isSearchable={false}
                                isClearable={!field.required}
                                isMulti={field.type === 'multiselect'}
                                getOptionValue={option => option[`${field.fk_field}`]}
                                getOptionLabel={option => option[`${field.fk_label}`]}
                                value={record[field.name]}
                                styles={{
                                  control: styles => ({
                                    ...styles,
                                    borderColor: formErrors[field.name] ? '#ff3d60' : styles.borderColor,
                                    '&:hover': {
                                      borderColor: formErrors[field.name] ? '#ff3d60' : styles['&:hover'].borderColor,
                                    },
                                  }),
                                }}
                                loadOptions={async () => {
                                  try {
                                    const res = await oikosApi.get('/', {
                                      action: 'get',
                                      table: field.fk_table,
                                    })

                                    if (record[field.name] !== undefined) {
                                      this.setState(prevState => ({
                                        record: {
                                          ...prevState.record,
                                          [field.name]: res.data.find(i => i[field.fk_field] === record[field.name]),
                                        },
                                      }))
                                    }

                                    return res.data
                                  } catch (e) {
                                    return notifyError(e)
                                  }
                                }}
                                onChange={e => this.setState(prevState => ({
                                  record: {
                                    ...prevState.record,
                                    [field.name]: e,
                                  },
                                  formErrors: {
                                    ...prevState.formErrors,
                                    [field.name]: undefined,
                                  },
                                }))}
                              />
                            )}

                            {!field.primary && field.type !== 'currency' && field.type !== 'select'
                              && field.type !== 'multiselect' && (
                                <Input
                                  invalid={formErrors[field.name]}
                                  type={field.type}
                                  rows={field.type === 'textarea' ? 3 : false}
                                  value={record[field.name]}
                                  onChange={e => this.setState({
                                    record: {
                                      ...record,
                                      [field.name]: e?.target?.value,
                                    },
                                    formErrors: {
                                      ...formErrors,
                                      [field.name]: undefined,
                                    },
                                  })}
                                />
                            )}

                            <FormFeedback
                              className={'d-block '.concat(formErrors[field.name] ? 'visible' : 'invisible')}
                            >
                              {formErrors[field.name]}
                            </FormFeedback>
                          </FormGroup>
                        </Col>
                      ))}
                    </Row>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              <hr className="mt-2 mb-4" />
            </Col>
          </Row>

          <Row>
            <Col className="d-flex justify-content-end">
              <Button
                type="button"
                color="primary"
                className="ml-3"
                disabled={handleFormSubmitIsLoading}
                onClick={() => {
                  if (addRecordModalIsOpen) this.handleFormSubmit('insert')
                  if (editRecordModalIsOpen) this.handleFormSubmit('update')
                }}
              >
                Enviar
                {(handleFormSubmitIsLoading) && (
                  <Spinner size="sm" className="ml-2" />
                )}
              </Button>
            </Col>
          </Row>
        </>
      )
    }

    return (
      <>
        <DeleteRecordByAdmin
          isOpen={deleteRecordModalIsOpen}
          recordId={deleteRecordId}
          recordType="setor"
          recordName={deleteRecordName}
          toggle={() => this.setState({
            deleteRecordModalIsOpen: !deleteRecordModalIsOpen,
          })}
        />

        <Row>
          <Col>
            <h4>
              Lista
            </h4>
          </Col>

          <Col className="d-flex justify-content-end">
            <Button outline color="primary" onClick={() => this.toggleModal('insert')}>
              Adicionar
            </Button>
          </Col>
        </Row>

        <Row className="mt-3">
          <Col>
            <Card>
              <CardBody className="pb-1">
                {getRecordsIsLoading && (
                  <Row>
                    <Col className="d-flex align-items-center justify-content-center py-3">
                      <Spinner size="sm" />
                    </Col>
                  </Row>
                )}

                {!getRecordsIsLoading && records && (
                  <DataTable
                    data={{
                      columns: [
                        {
                          label: 'ID',
                          field: 'setor_id',
                        },
                        {
                          label: 'Nome',
                          field: 'setor_nome',
                        },
                        {
                          label: 'Departamento',
                          field: 'dpto',
                        },
                        {
                          label: 'Ações',
                          field: 'actions',
                          sort: 'disabled',
                        },
                      ],
                      rows: records.map(record => ({
                        ...record,
                        dpto: departmentTypes?.find(t => t.value === record.dpto_id)?.label,
                        actions: (
                          <div>
                            <Button
                              size="sm"
                              color="light"
                              onClick={() => {
                                this.setState({ record, editRecordModalIsOpen: true })
                              }}
                            >
                              <i className="ri-pencil-fill" />
                            </Button>

                            <Button
                              size="sm"
                              color="light"
                              className="ml-2"
                              onClick={() => this.setState({
                                deleteRecordModalIsOpen: true,
                                deleteRecordId: record.setor_id,
                                deleteRecordName: record.setor_nome,
                              })}
                            >
                              <i className="ri-delete-bin-6-line" />
                            </Button>
                          </div>
                        ),
                      })),
                    }}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </>
    )
  }
}

const mapStateToProps = state => ({
  types: state.types,
  admin: state.admin,
  forms: state.forms,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getSectors,
  getDepartmentTypes,
  getFieldsForSectors,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Sectors)
